"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapConnectorResponse = void 0;
const urls_1 = __importDefault(require("./urls"));
const mapConnectorResponse = (c) => ({
    name: c.name,
    id: c.id,
    displayName: c.display_name,
    thumbnailUrl: c.thumbnail_url,
});
exports.mapConnectorResponse = mapConnectorResponse;
class ConnectorClient {
    getConnectors(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const sortByMap = {
                createdAt: 'created_at',
                updatedAt: 'updated_at',
            };
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.connectors({
                    page: params.page,
                    page_size: params.pageSize,
                    sort_by: params.sortBy && sortByMap[params.sortBy],
                    sort_direction: params.sortDirection,
                }),
            });
            return {
                total: data.total,
                data: data.data.map(exports.mapConnectorResponse),
            };
        });
    }
}
exports.default = ConnectorClient;
